import { apiRequest } from ".";

export const getFirmwareAPI = (data) => {
  return apiRequest({
    method: "get",
    url: `admin/settings/firmware`,
    queryParams: data,
  });
};
export const addFirmwareAPI = (data) => {
  return apiRequest({
    method: "put",
    url: `admin/settings/firmware`,
    data: data,
  });
};

export const publishV2FirmwareAPI = (data) => {
  return apiRequest({
    method: "post",
    url: `admin/settings/firmware/v2`,
    data,
  });
};
